export default {
  message: {
    "error": "エラーが発生しました！",
    "Sorrysomeerrorsoccurred": "申し訳ありませんが、いくつかのエラーが発生しました",
    "quit": "終了",
    "language": "言語",
    "Youcanchangethelanguagehere": "ここで言語を変更できます！",
    "current": "現在",
    "home": "ホーム",
    "friends": "友達",
    "wallet": "ウォレット",
    "aboutus": "私たちについて",
    "Sharewithfriends": "友達と共有",
    "copyFailure": "コピー失敗",
    "copySuccess": "コピー成功",
    "Claimreward": "報酬を受け取る",
    "DailyLogin": "毎日のログイン",
    "noInvitationsYet": "まだ招待はありません",
    "LoadMore": "もっと読み込む",
    "WatchAD": "広告を視聴",
    "continue": "続ける",
    "Congratulations": "おめでとうございます",
    "MyFriends": "私の友達",
    "Invitefriends": "友達を招待",
    "Invitepremiumfriends": "プレミアム友達を招待",
    "DailyTasks": "日々のタスク",
    "inviteDesc": "招待した友達につき+{num} ${name}",
    "DailyTasksDesc": "タスクを完了してもっと ${name} を手に入れよう",
    "SponsorsandPartners": "スポンサーとパートナー",
    "Receivingwallet": "受信ウォレット",
    "Enterwalletaddress": "{name} ウォレットアドレスを入力",
    "Claim": "報酬を受け取る",
    "Booster": "ブースター",
    "RentPeriod": "レンタル期間",
    "days30": "30日",
    "days": "日",
    "Dailyprofit": "毎日の利益",
    "Totalprofit": "総利益",
    "Quantity": "数量",
    "RentPrice": "レンタル価格",
    "RentMiner": "マイナーをレンタル",
    "Insufficient": "不足している ${name}",
    "InsufficientMsg": "{num} ${name1} が必要です。友達を招待するか、タスクを完了してもっと ${name2} を稼いでください。",
    "Settings": "設定",
    "copyid": "IDをコピー",
    "UpgradeSuccessfully": "アップグレードに成功",
    "Name": "名前",
    "userinfo": "ユーザー情報",
    "disconnect": "切断",
    "Startmining": "マイニングを開始",
    "Welcome": "{name} へようこそ",
    "Withdrawal": "出金",
    "Minimumamount": "最低額",
    "Networkfee": "ネットワーク手数料",
    "Enteramount": "金額を入力",
    "Submit": "送信",
    "MinimumTip": "引き出し金額が小さすぎます。最小引き出し金額：{num}",
    "MaximumTip": "金額が不足しています。引き出せる最大金額は：{num}",
    "SubmittedTip": "送信しました。30-60営業日以内に処理される予定です",
    "WebSubmittedTip": "送信しました。24-48時間以内に処理される予定です",
    "WithdrawStatus": "ステータス",
    "Submissiontime": "送信時間",
    "WithdrawAwaitTip": "* 30-60営業日かかる見込みです。友達をもっと招待することでレビュープロセスを早めることができます。",
    "WebWithdrawAwaitTip": "* 24-48時間かかる見込みです。友達をもっと招待することでレビュープロセスを早めることができます。",
    "Processing": "処理中",
    "Success": "成功",
    "Rejection": "拒否",
    "Amount": "金額",
    "Numberoffriends": "友達の数：{now}/{limit}",
    "InviteTip": "最初の引き出しのためには、{limit}人の友達をマイニングアプリに招待する必要があります。",
    "openonphone": "このリンクをスマホで開いてください。",
    "claimTip": "請求する金額が小さすぎます。最小請求金額は：{num}",
    "WalletBalance": "ウォレット残高",
    "Withdraw": "引き出す",
    "SetWalletAddress": "ウォレットアドレスを設定",
    "WithdrawalRecord": "引き出し記録",
    "Norecords": "記録はありません",
    "Whatis": "{name}とは何ですか？",
    "All": "すべて",
    "save": "保存",
    "successWithdrawal": "引き出しが受け取りました {num}",
    "secondsago": "{time}秒前",
    "Loading": "読み込み中...",
    "PaymentConfirming": "取引ステータスを確認中...",
    "Check": "確認",
    "CheckFail": "取引が完了していません。5秒後に再度確認してください。",
    "Addname": "'{name}'を名前に追加",
    "Restattcheck": "確認するためにアプリを再起動してください",
    "Copyname": "'{name}'をコピー",
    "SubmissionFailed": "送信に失敗しました。後で再試行してください。",
    "WithdrawalReview": "引き出しレビュー",
    "shop": "ショップ",
    "topurchase": "購入するためにショップに行く",
    "shopDesc": "数量限定—無くなる前にゲットしよう！",
    "select_payment_method": "支払方法を選択",
    "total_amount": "合計金額",
    "creating_order": "注文を作成中...",
    "order_created": "注文が作成されました",
    "order_status": "注文ステータス",
    "claim": "報酬を受け取る",
    "payment_success": "支払い成功",
    "payment_failed": "支払い失敗",
    "payment_cancelled": "支払いキャンセル",
    "opening_payment": "支払いを開始しています...",
    "payment_status": "支払い状況",
    "create_order_failed": "注文の作成に失敗しました",
    "creating_ton_order": "TON注文を作成しています...",
    "next_step": "次のステップ",
    "use_ton_payment": "TON支払いを使用する",
    "start_transaction": "取引を開始する",
    "connect_wallet": "ウォレットを接続する",
    "address": "アドレス",
    "amount_ton": "量 TON",
    "copy": "コピー",
    "amount": "金額",
    "wallet_address": "ウォレットアドレス",
    "comment_memo": "コメントメモ",
    "you_can_choose_to_connect_wallet_to_pay": "支払いのためにウォレットを接続することができます",
    "or_manually_transfer_to_the_above_address": "または、上記のアドレスに手動で送金してください（金額とメモは正確に同じでなければなりません）",
    "transaction_success": "取引成功",
    "transaction_failed": "取引失敗",
    "transaction_error": "取引エラー",
    "transaction_status": "取引状況",
    "transaction_id": "取引ID",
    "transaction_amount": "取引金額",
    "transaction_status_desc": "取引状況の説明",
    "payment_status_tip": "支払いの確認をお待ちください",
    "Applyforwithdrawal": "出金を申請する",
    "Withdrawalunlock": "出金解除中",
    "Close": "閉じる",
    "Delivering": "配信中",
    "Duetothelargenumber": "受取人が多いため、エアドロップは15〜20営業日以内に到着する予定です",
    "WithdrawalunlockTip": "出金を解除するためには{num}の友達を招待し、タスクを完了/ウォレットをバインドする必要があります",
    "select_network": "ネットワークを選択",
    "confirm": "確認",
    "switching_network": "ネットワークを切り替えています...",
    "network_switched": "ネットワークが切り替わりました",
    "use_usdt_payment": "USDTで支払う",
    "or_manually_transfer_to_the_above_address_usdt": "上記のアドレスに手動で送金してください（送金額とアドレスは正確に一致する必要があります）",
    "chain_type": "ネットワーク",
    "check_transaction_status": "取引のステータスを確認",
    "transaction_wait": "取引は処理中です。アプリを終了してもかまいません。完了したらメッセージでお知らせします。",
    "twa_pay_tip_with_memo": "送金のために、住所、金額、メモが一致していることを確認してください。",
    "twa_pay_tip": "送金のために、住所と金額が正しいことを確認してください。",
    "creating_usdt_order": "USDT注文を作成中...",
    "affiliate_programs": "アフィリエイトプログラム",
    "affiliate_programs_description": "友達をマイニングアプリに招待して報酬を獲得しましょう。",
    "commission_details": "手数料の詳細",
    "no_commission_records": "手数料記録はありません",
    "commission_list": "手数料リスト",
    "input_amount": "金額を入力",
    "max": "最大",
    "commission_input_amount": "手数料の金額を入力",
    "min_commission": "最低出金額は {num} です",
    "WithdrawalSuccess": "出金成功",
    "WithdrawalFailed": "出金失敗",
    "WithdrawalProcessing": "出金処理中",
    "award": "報酬",
    "level": "レベル",
    "Share_to_group": "グループに共有",
    "Exchange": "交換",
    "balance_not_enough": "残高が不足しています。{num} {coin} しか交換できません",
    "exchange_fail": "交換に失敗しました",
    "exchange_success": "交換に成功しました",
    "you_will_receive": "あなたは受け取ります",
    "ShareToGroups": "グループに共有する",
    "Numberofgroups": "グループ数: {now}/{limit}",
    "Confirm": "確認する",
    "ShareToGroupsDesc": "グループに共有して {name} をもっと取得してください",
    "TokenAddress": "取引所IDまたはUSDTアドレスの引き出し詳細を入力してください",
    "CashAddress": "銀行カード番号またはUSDTアドレスの引き出し詳細を入力してください",
    "Cancel": "キャンセル",
    "min_withdrawal_amount": "最小出金額は {num} {coin} です。",
    "max_withdrawal_amount": "最大出金額は {num} {coin} です。",
    "withdrawal_failed": "出金に失敗しました",
    "withdrawal_success": "出金成功",
    "PayNow": "今すぐ支払う",
    "PaySkip": "即座に引き出しを解除するには {num} を支払ってください",
    "NumberofGroups": "グループの数: {now}/{limit}",
    "SendMessage": "メッセージを送信",
    "NumberofShares": "シェアの数: {now}/{limit}",
    "NumberofTasks": "タスクの数: {now}/{limit}",
    "CompleteTask": "タスクを完了",
    "PleaseEnterValidAmount": "有効な金額を入力してください",
    "PleaseEnterValidEmail": "有効なメールアドレスを入力してください",
    "Feedback": "フィードバック",
    "Inputfeedbackcontent": "フィードバック内容を入力してください",
    "Submitfeedback": "フィードバックを送信する",
    "Pleaseenteravalidemailaddress": "有効なメールアドレスを入力してください",
    "Pleaseenteryouremailaddress": "メールアドレスを入力してください",
    "Youhavealreadyfeedbackedtoday_pleasecomebacktomorrow": "今日はすでにフィードバックをいただきましたので、明日またお越しください",
    "Feedback_submitted_successfully_thank_you_for_your_valuable_feedback": "フィードバックが正常に送信されました。貴重なフィードバックをありがとうございます",
    "Feedback_submission_failed_please_retry": "フィードバックの送信に失敗しました。再試行してください",
    "ContactUs": "お問い合わせ",
    "XRPAddress": "アクティブなXRPチェーンのウォレットアドレス（MEMOを含む）を入力してください。そうしないと、現金を引き出すことができません。",
    "Accelerated": "加速",
    "Accelerated_withdrawals_success": "加速した引き出しが成功しました",
    "login": "ログイン",
    "register": "登録",
    "login_with_google": "Googleでログイン",
    "or": "または",
    "email": "メールアドレス",
    "password": "パスワード",
    "no_account": "アカウントをお持ちでない場合",
    "click_to_go": "クリックして",
    "have_account": "すでにアカウントをお持ちの場合",
    "go_to": "移動する",
    "invite_code": "招待コード",
    "optional": "任意",
    "google_login_not_ready": "Googleログインは準備中です。後でもう一度お試しください",
    "password_too_long": "パスワードが長すぎます",
    "weak": "弱い",
    "medium": "普通",
    "strong": "強い",
    "login_success": "ログイン成功",
    "login_failed": "ログイン失敗",
    "please_input_email": "メールアドレスを入力してください",
    "invalid_email": "無効なメール形式です",
    "please_input_password": "パスワードを入力してください",
    "password_length_6_to_16": "パスワードは6〜16文字でなければなりません",
    "account_or_password_error": "アカウントまたはパスワードエラー",
    "register_success": "登録成功",
    "register_failed": "登録失敗",
    "save_error": "保存エラーです、後で再試行してください",
    "ShareToFriends": "友達に共有",
    "login_first": "まずログインしてください",
    "WalletBscError": "❌ 無効なBNBチェーンのウォレットアドレス。",
    "DownloadWallet": "ウォレットをダウンロード",
    "AddToHomeScreen": "ホーム画面に{appName}を追加",
    "TapShareInToolbar": "ツールバーをタップ",
    "SelectAddToHomeScreen": "ホーム画面に追加を選択",
    "OpenToolbar": "ツールバーを開く",
    "ClaimFailed": "報酬の受け取りに失敗しました。後でもう一度お試しください。",
    "guest_login": "ゲストログイン",
    "please_input_phone": "電話番号を入力してください",
    "email_error_1": "メールアドレスを入力してください",
    "email_error_2": "有効なメールアドレスを入力してください",
    "email_error_3": "ゲストメールは許可されていません。本物のメールを使用してください",
    "phone": "電話",
    "phone_error_1": "電話番号を入力してください",
    "phone_error_2": "有効な電話番号を入力してください",
    "update_info": "情報を更新",
    "update_success": "更新成功",
    "update_failed": "更新に失敗しました。後で再試行してください",
    "cancel": "キャンセル",
    "guest_credentials_title": "アカウント情報",
    "guest_credentials_warning": "アカウントとパスワードを保存するためにスクリーンショットを撮ってください。失われた場合、あなたの収益は回復できません！",
    "i_have_saved": "私は保存しました",
    "account": "アカウント",
    "view_credentials": "資格情報を見る",
    "miner_max_reached": "このマイナーの最大数に達しました"
}};